import { isWebBridgeSupported } from '@shopee/web-bridge-sdk'
import { usePathname, useSearchParams } from 'next/navigation'
import { Suspense, useEffect } from 'react'
import { UNIVERSAL_LINK } from 'shared/constants'
import { getViewType, navigateToUrl } from 'shared/helpers'

const OpenShopeeAppComponent = () => {
  const pathName = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (!isWebBridgeSupported() && searchParams.get('visited') !== 'true' && getViewType() === 'mobile') {
      const params = new URLSearchParams(searchParams.toString())
      params.set('visited', 'true')
      navigateToUrl(
        `${UNIVERSAL_LINK}?redir=${encodeURIComponent(process.env.BASE_URL + '/' + pathName + '?' + params.toString() + window.location.hash)}`,
        true,
      )
    }
  }, [searchParams, pathName])

  return null
}

const OpenShopeeApp = () => (
  <Suspense fallback={null}>
    <OpenShopeeAppComponent />
  </Suspense>
)

export default OpenShopeeApp
